<template>
  <div class="job-category">
    <v-row>
      <v-col cols="4">
        <v-select
          v-model="search.device_status"
          :items="assetStatus"
          item-text="label"
          item-value="value"
          label="Status"
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="search.organisation"
          label="Organisation"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.name" label="Asset Name"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.imei" label="IMEI"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.iccid" label="SIM ICCID"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.serial_number" label="Serial"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.make" label="Device Make"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.model" label="Device Model"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="search.firmware_version"
          label="Firmware Version"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Logger } from "aws-amplify";
const logger = new Logger("Advanced Search / Assets");
import { pageCache } from '@/mixins/page-cache.js';

export default {
  name: "AssetTrackers",
  mixins: [
    pageCache('globalsearchassettrackers')
  ],
  props: {
    reset: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      searching: false,
      search: {
        device_status: "",
        organisation: "",
        group: "",
        name: "",
        imei: "",
        iccid: "",
        serial_number: "",
        make: "",
        model: "",
        firmware_version: "",
      },

      assetStatus: [
        {
          label: "Assigned",
          value: "assigned",
        },
        {
          label: "Unassigned",
          value: "unassigned",
        },
      ],
    };
  },
  watch: {
    search: {
      handler(val) {
        this.$emit("updatedSearchCriteria", val);
      },
      deep: true,
    },
    reset() {
      this.resetFields();
    },
  },
  mounted() {
    this.search.device_status = 'assigned'
  },
  methods: {
    resetFields() {
      logger.info("clear them fields");

      for (var key in this.search) {
        if (this.search.hasOwnProperty(key)) {
          this.search[key] = "";
        }
      }
    },
  },
};
</script>
